import {connect} from 'react-redux'
import {PaginatorWithResult} from 'jbc-front/components/SearchForm'
import {autofill, submit} from 'redux-form'
import {fetchSelector} from 'actions'
import {formName, selector} from 'settings/clientRoles/utils'

const mapStateToProps = (state) => ({
  count: fetchSelector(state, 'users_clients').count,
  isLoading: fetchSelector(state, 'users_clients').loading,
  page: selector(state, 'page'),
})
const mapDispatchToProps = (dispatch) => ({
  onClick: (page) => {
    dispatch(autofill(formName, 'page', page.toString()))
    dispatch(submit(formName))
  },
})
export default connect(mapStateToProps, mapDispatchToProps)(PaginatorWithResult)
